import { render } from "./ChallengesTable.vue?vue&type=template&id=54f9d0e8"
import script from "./ChallengesTable.vue?vue&type=script&lang=js"
export * from "./ChallengesTable.vue?vue&type=script&lang=js"
script.render = render

export default script